export class UploadError extends Error {
  constructor (message: string, readonly retryable: boolean) {
    super(message);
  }
}

export const uploadFileToS3 = async (file: File, uploadUrl: string): Promise<void> => {
  const uploadResponse = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
      'x-amz-server-side-encryption': 'AES256',
    },
    credentials: 'omit',
  });

  if (!uploadResponse.ok) {
    if (uploadResponse.status === 403) {
      console.error('S3 upload failed: presigned URL likely expired', {
        status: uploadResponse.status,
        statusText: uploadResponse.statusText,
      });
      throw new UploadError('Upload link expired. Please try again.', false);
    }
    console.error('S3 upload failed', {
      status: uploadResponse.status,
      statusText: uploadResponse.statusText,
    });
    throw new UploadError('Upload failed. Please try again.', true);
  }
};
